// extracted by mini-css-extract-plugin
export var active = "_b2-7";
export var container = "_b2-0";
export var evenWidth = "_b2-4";
export var large = "_b2-5";
export var outlet = "_b2-8";
export var slide = "_b2-2";
export var small = "_b2-6";
export var tab = "_b2-3";
export var tabs = "_b2-1";